export enum PARENT_COMPANY_FINANCIAL_SOURCE {
    FINANCIALS = 'Financials',
    NEWS = 'News',
    WEBSITE = 'Website',
    DISCLOSURE = 'Disclosure',
    OTHER = 'Other',
}
